import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Class-name merger: `clsx()` for conditional logic + `tailwind-merge` to
 * dedupe conflicting Tailwind classes (last one wins). Use this everywhere
 * you compose className props.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
